import { NotificationEventItem } from '@cims-online/shared'
import { useCIMSNotificationsPanelContext } from '../../CIMSNotificationsPanelContext'
import { useCIMSNotificationsContext } from '../../../CIMSNotificationsContext'

function ViewContent<T extends NotificationEventItem>() {
  const { event } = useCIMSNotificationsPanelContext<T>()
  const { view } = useCIMSNotificationsContext()
  return <>{typeof view === 'function' ? view(event) : view}</>
}

export default ViewContent
